"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VM_MEDIUM_OBFUSCATION_PRESET = exports.VM_MEDIUM_OBFUSCATION_PRESET_VM_OPTIONS = void 0;
const OptionsPreset_1 = require("../../enums/options/presets/OptionsPreset");
const NoCustomNodes_1 = require("./NoCustomNodes");
const IdentifierNamesGenerator_1 = require("../../enums/generators/identifier-names-generators/IdentifierNamesGenerator");
const VMBytecodeFormat_1 = require("../../enums/vm-transformers/VMBytecodeFormat");
exports.VM_MEDIUM_OBFUSCATION_PRESET_VM_OPTIONS = {
    vmObfuscation: true,
    vmObfuscationThreshold: 1,
    vmOpcodeShuffle: true,
    vmBytecodeEncoding: true,
    vmBytecodeArrayEncoding: true,
    vmJumpsEncoding: true,
    vmDecoyOpcodes: true,
    vmDeadCodeInjection: true,
    vmSplitDispatcher: true,
    vmMacroOps: true,
    vmDebugProtection: false,
    vmRuntimeOpcodeDerivation: true,
    vmStatefulOpcodes: true,
    vmStackEncoding: true,
    vmRandomizeKeys: true,
    vmIndirectDispatch: true,
    vmBytecodeFormat: VMBytecodeFormat_1.VMBytecodeFormat.Binary
};
exports.VM_MEDIUM_OBFUSCATION_PRESET = Object.freeze({
    ...NoCustomNodes_1.NO_ADDITIONAL_NODES_PRESET,
    ...exports.VM_MEDIUM_OBFUSCATION_PRESET_VM_OPTIONS,
    optionsPreset: OptionsPreset_1.OptionsPreset.VMMediumObfuscation,
    compact: true,
    simplify: true,
    identifierNamesGenerator: IdentifierNamesGenerator_1.IdentifierNamesGenerator.MangledShuffledIdentifierNamesGenerator
});
